import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutingService } from '../security/services/routing.service';
import { SecurityService } from '../security/services/security.service';
import { SecurityHelperService } from '../security/services/security-helper.service';
import { SubjectObliged } from '../models/subject-obliged';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public router: Router,
    private securityService: SecurityService,
    private securityHelperService: SecurityHelperService,
    private routingService: RoutingService
  ) {}
  private navigateToLoginPage = () => this.router.navigate(['login']);

  private isAuthenticated(): Observable<boolean> {
    const response = this.securityService.isLoggedIn();
    response.subscribe(
      (res) => {
        if (!res || !this.securityHelperService.subjectObligedId) {
          this.navigateToLoginPage();
          return;
        }

        this.securityService.isSecurityComplaint().toPromise().then(isCompliant => {
          if (!isCompliant) {
            this.router.navigate(['app/account']);
            return false;
          }
          else
            return true;
        });

      },
      (error) => {
        console.error(error);
        this.navigateToLoginPage();
      }
    );
    return response;
  }
  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAuthenticated();
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAuthenticated();
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.isAuthenticated();
  }
}
